import { render, staticRenderFns } from "./mfaTemplate.vue?vue&type=template&id=4cad00ea&scoped=true&"
import script from "./mfaTemplate.vue?vue&type=script&lang=js&"
export * from "./mfaTemplate.vue?vue&type=script&lang=js&"
import style0 from "./mfaTemplate.vue?vue&type=style&index=0&id=4cad00ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cad00ea",
  null
  
)

export default component.exports